import { Trans } from 'react-i18next';
import classnames from 'classnames/bind';
import { useSelector } from 'app/lib/hooks';
import { selectIsLicenseWarningBannerEnabled } from 'app/store/applicationConfig/selectors';
import * as styles from './SnowflakeDisconnectedOverlay.css';

const cx = classnames.bind(styles);

export function LicenseWarningOverlay() {
    const isLicenseWarningBannerEnabled = useSelector(selectIsLicenseWarningBannerEnabled);

    if (!isLicenseWarningBannerEnabled) {
        return null;
    }

    if (window.location.hostname.split('.').at(0) !== 'alpura') {
        return null;
    }

    return (
        <div className={cx('banner', 'isError')}>
            <Trans i18nKey="components:LicenseWarningOverlay.message" components={{ a: <a /> }} />
            <div className={cx('frame', 'isError')} />
        </div>
    );
}
